import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

const ProgressDialog = ({ visible, msg }) => {
  return (
    <Dialog open={visible}>
      <DialogContent>
        <Box display="flex" alignItems="center">
          <CircularProgress color="primary" />
          {msg && (
            <Typography variant="body1" sx={{ ml: 2 }}>
              {msg}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProgressDialog;
